import Search from './search';

document.addEventListener('DOMContentLoaded', () => new Search());
